import { useState } from "react";

const statusLabels = {
  delayed: "Atrasada",
  on_track: "No caminho",
  ahead: "Adiantada",
  future: "Futura",
  completed: "Concluída",
  no_measurement: "Sem medição",
};

const formatPercentage = (value) =>
  value == null ? "—" : `${(Number(value) * 100).toFixed(1).replace(".", ",")}%`;

const formatDate = (value) => {
  if (!value) return "—";
  const [year, month, day] = String(value).slice(0, 10).split("-");
  return year && month && day ? `${day}/${month}/${year}` : "—";
};

const ScheduleActivityRow = ({ row }) => {
  const [expanded, setExpanded] = useState(false);
  const deviation = row.deviationPp == null
    ? "—"
    : `${row.deviationPp > 0 ? "+" : ""}${String(row.deviationPp).replace(".", ",")} p.p.`;

  return (
    <article
      className={`schedule-activity-row status-${row.status}`}
      data-testid={`schedule-row-${row.activityId}`}
    >
      <button
        type="button"
        className="schedule-activity-toggle"
        aria-expanded={expanded}
        aria-controls={`schedule-detail-${row.activityId}`}
        onClick={() => setExpanded((current) => !current)}
      >
        <span className="schedule-activity-name">
          <strong>{row.displayName}</strong>
          <small>
            {row.critical ? "Caminho crítico · " : ""}
            {statusLabels[row.status] ?? row.status}
          </small>
        </span>
        <span data-label="Previsto">{formatPercentage(row.expectedPercentage)}</span>
        <span data-label="Medido">{formatPercentage(row.realizedPercentage)}</span>
        <span data-label="Desvio" className="schedule-deviation">{deviation}</span>
        <span aria-hidden="true">{expanded ? "−" : "+"}</span>
      </button>
      {expanded && (
        <div
          className="schedule-activity-detail"
          id={`schedule-detail-${row.activityId}`}
        >
          <dl>
            <div><dt>Início base</dt><dd>{formatDate(row.baselineStartAt)}</dd></div>
            <div><dt>Fim base</dt><dd>{formatDate(row.baselineEndAt)}</dd></div>
            <div><dt>Início atual</dt><dd>{formatDate(row.startAt)}</dd></div>
            <div><dt>Fim atual</dt><dd>{formatDate(row.endAt)}</dd></div>
            <div><dt>Medições</dt><dd>{row.measurementCount ?? 0}</dd></div>
          </dl>
          {(row.milestones ?? []).length > 0 && (
            <div className="schedule-milestones">
              <strong>Marcos</strong>
              <ul>
                {row.milestones.map((milestone) => (
                  <li key={milestone.id ?? milestone.name}>{milestone.name}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </article>
  );
};

export default ScheduleActivityRow;
